import { formatPrice } from "@grandvisionhq/svc-tealium/utils";
import { getLocalizedString } from "@grandvisionhq/utils";
const getOrderPriceInfo = (order) => {
  const Order_ProductsAmount = order.rawLineItems.reduce((prev, next) => {
    const productDiscount = next.price.unit.discount.appliedDiscounts.filter((item) => item.type === "PRODUCT_DISCOUNT").reduce((prev2, next2) => prev2 + next2.amount, 0);
    return prev + (next.price.unit.subtotal - productDiscount) * next.quantity;
  }, 0);
  return {
    Order_Subtotal: order.totalPrice && order.taxAmount ? formatPrice(order.totalPrice - order.taxAmount - order.shippingMethodPrice, true) : "0",
    Order_Total: order.totalPrice ? formatPrice(order.totalPrice, true) : "0",
    Order_TaxAmount: order?.taxAmount ? formatPrice(order.taxAmount, true) : "0",
    Order_ShippingTaxRate: order?.shippingTaxRate ? formatPrice(order.shippingTaxRate, false) : "0",
    Order_ShippingDiscount: order.shippingDiscount ? `-${formatPrice(order.shippingDiscount, true)}` : "0",
    Order_ShippingAmount: formatPrice(order.shippingMethodPrice, true),
    Order_ProductsAmount: formatPrice(Order_ProductsAmount, true)
  };
};
const orderToTealiumOrderDiscountInfo = (order) => {
  const localizedDiscounts = [];
  const discountCodes = [];
  order.discountCodes?.forEach((discountItem) => {
    discountCodes.push(discountItem.code);
    const localizedName = getLocalizedString(discountItem.name, "en");
    localizedName && localizedDiscounts.push(localizedName);
  });
  const orderDiscount = order?.appliedDiscounts ? order.appliedDiscounts.filter((item) => item.type === "CART_DISCOUNT").reduce((prev, next) => prev + next.value, 0) : 0;
  return {
    Order_DiscountAmount: orderDiscount ? `-${formatPrice(orderDiscount, true)}` : "0",
    Order_DiscountCode: discountCodes.join(),
    Order_DiscountName: localizedDiscounts.join()
  };
};
const getOrderSubscriptionFrequency = (order) => {
  if (!order.hasSubscription) {
    return "0";
  } else {
    const subscriptionProduct = order.lineItems.filter((item) => "subscriptionDetails" in item)[0];
    if (!subscriptionProduct || !subscriptionProduct.subscriptionDetails) {
      return "0";
    } else {
      return Math.floor(subscriptionProduct.subscriptionDetails.deliveryInterval / 30).toFixed(1);
    }
  }
};
export {
  getOrderPriceInfo,
  getOrderSubscriptionFrequency,
  orderToTealiumOrderDiscountInfo
};
//# sourceMappingURL=tealium-mapper.js.map
